// ── MFMO Default Unit Cost Rates (Jacksonville, FL market) ──────────────────
// All amounts in USD. Edit here to adjust market rates globally.

export const COST_RATES = {

  // ── Flooring (installed, per sqft) ──────────────────────────────────────
  flooring: {
    LVP:      3.50,
    carpet:   2.50,
    tile:     5.00,
    hardwood: 8.00,
    none:     0,
  },

  // ── Interior Paint ───────────────────────────────────────────────────────
  paint_walls_per_sqft:   1.50,  // applied to wall area (perimeter × height)
  paint_ceiling_per_sqft: 1.00,  // applied to room sqft
  drywall_minor:           500,
  drywall_major:          2000,

  // ── Electrical (per unit) ────────────────────────────────────────────────
  light_fixture:  150,
  ceiling_fan:    200,
  door_replace:   200,   // per door (interior)

  // ── Kitchen ──────────────────────────────────────────────────────────────
  cabinet_paint:            500,
  cabinet_reface:          2500,
  cabinet_replace_per_lft:  300,  // per linear foot
  countertop: {
    laminate:      20,  // per sqft
    granite:       65,
    quartz:        70,
    tile:          15,
    solid_surface: 45,
    butcher_block: 55,
    marble:        80,
    concrete:      65,
    other:         40,
  },
  sink_replace: 200,
  appliance: {
    fridge:      800,
    stove:       500,
    dishwasher:  400,
    microwave:   200,
    disposal:    150,
  },

  // ── Bathroom ─────────────────────────────────────────────────────────────
  toilet_replace:        200,
  vanity_paint:          200,
  vanity_replace_single: 600,
  vanity_replace_double: 900,
  vanity_countertop: {
    cultured_marble: 400,
    laminate:        250,
    granite:         500,
    quartz:          550,
    solid_surface:   400,
    tile:            300,
    other:           350,
  },
  tub_retile_per_sqft: 12,
  tub_replace:       1500,
  exhaust_fan_replace: 150,

  // ── Demo & Disposal ───────────────────────────────────────────────────────
  dumpster: {
    '10yd': 350,
    '15yd': 425,
    '20yd': 500,
    '30yd': 650,
  },
  full_cleanout: 1500,
  haul_away:      500,

  // ── Roof (per sqft installed) ─────────────────────────────────────────────
  roof: {
    shingle: 4.50,
    flat:    6.00,
    metal:   8.00,
    tile:   10.00,
    other:   5.00,
  },
  roof_repair: 2000,

  // ── Plumbing ──────────────────────────────────────────────────────────────
  repipe_supply:    4500,
  plumbing_repair:  1500,
  wh_replace:        800,

  // ── Electrical Panel ─────────────────────────────────────────────────────
  panel_upgrade:  1500,
  panel_replace:  2500,

  // ── HVAC (replace, by tons) ───────────────────────────────────────────────
  hvac_replace: {
    1.5: 3500,
    2:   4000,
    2.5: 4500,
    3:   5000,
    3.5: 5500,
    4:   6000,
    5:   7000,
  },
  hvac_replace_default: 5000,
  hvac_service:          250,

  // ── Foundation ────────────────────────────────────────────────────────────
  foundation_repair: 5000,

  // ── Exterior ──────────────────────────────────────────────────────────────
  window_replace:           350,  // per window
  siding_replace_per_sqft:  5.00,
  ext_paint_per_sqft:       2.00,
  gutters_per_lft:          8.00,
  gutters_demo_per_lft:     2.00,  // demo/remove only
  pressure_wash_per_sqft:   0.15,

  // ── Landscape ─────────────────────────────────────────────────────────────
  landscape: {
    cleanup:       500,
    light_refresh: 1500,
    full_refresh:  3500,
    new_install:   6000,
  },
  sod_per_sqft:    0.45,
  tree_removal:     800,  // per tree
  irrigation_new:  2500,
  irrigation_repair: 800,

  // ── Fence (per linear foot) ───────────────────────────────────────────────
  fence: {
    wood:       25,
    chain_link: 15,
    vinyl:      30,
    iron:       40,
    other:      20,
  },

  // ── Driveway (per sqft) ───────────────────────────────────────────────────
  driveway: {
    concrete: 6,
    asphalt:  3,
    pavers:  10,
    gravel:   2,
  },
  driveway_repair: 1000,
};
